import { environment } from '../../../environments/environment';

export class Dep{
    static token: string = '';
    static user: any = '';
    static auth: any;
  
    static islogin():boolean{
        if(this.getData()){
            return true;
        }
        return false;
    }
    static logout(): boolean {
        localStorage.setItem('usertoken', '');
        this.token = '';
        location.reload();
        return true;
    }

    static faild(checkdata:any){
        let status = checkdata?.info?.status_code;
        // console.log(status,checkdata.msg,'ggwp');
        if(status*1 == 2 || status*1 == -1){
            this.logout();
        }else if(checkdata.msg=='token過期'){
            this.logout();
        }
    }

    static getData(): any {
        const savedVersion = localStorage.getItem('appVersion');
        if (savedVersion !== environment.appVersion) {
            localStorage.removeItem('usertoken');
            localStorage.setItem('appVersion', environment.appVersion);
            return false;
        }
        const tmp = localStorage.getItem('usertoken');
        if(!tmp)return false;
        const index:any = tmp.indexOf("%gg%");
        if(index===false){
            return false;
        }
        const arr = tmp.split("%gg%");
        if(arr.length==3){
            const user =   JSON.parse(window.atob(arr[1]))  
            const user_pow =   JSON.parse(window.atob(arr[2]))  
            this.user = user;
            this.token = tmp;  
            this.auth = user_pow;   
			this.user.powers = user_pow;

            return user;    
        }else{
            return false;
        }
       
    }
    static setData(token:string): void {
        // console.log(token,'ggwp');
        localStorage.setItem('usertoken', token);
        localStorage.setItem('appVersion', environment.appVersion);
        // 2026-07-05 同步更新記憶體 token。原本只寫 localStorage，登入/背景換發(fresh_token)後
        // 攔截器仍送舊(或空)Dep.token，要等下一次 getData() 才生效；在 agentmember 這類一進頁
        // 就狂打平行 API 的頁面易誤送舊 token → 後端回 token過期 → 被強制登出(重登也沒用)。
        this.token = token;
    }
}

